
import React, { useRef, useContext } from "react";
import { getClubId } from "src/api/CalendarBooking";
import { useMediaQuery } from "@mui/material";
import theme from "src/theme";
import MainContext from "src/context/MainContext";

const CHAT_ORIGIN = "https://support-platform.vercel.app";

interface ChatSupportProps {
  hideLauncher?: boolean;
}

const ChatSupport: React.FC<ChatSupportProps> = ({ hideLauncher = false }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const clubId = getClubId();
  // Note: hasUnreadSupport is managed by useSupportUnreadCount hook in MainProvider
  // Do NOT set it from iframe messages - that was causing conflicts
  const { isChatVisible, setIsChatVisible, hasUnreadSupport } = useContext(MainContext);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const toggleChat = () => {
    const nextVisible = !isChatVisible;
    setIsChatVisible(nextVisible);
  };

  if (!clubId) return null;

  return (
    <>
      {/* Chat Iframe */}
      <iframe
        ref={iframeRef}
        id="chatWidgetIframe"
        src={`${CHAT_ORIGIN}/widget/${clubId}`}
        allow="display-capture"
        className={isChatVisible ? "visible" : "hidden"}
        style={{
          display: isChatVisible ? "block" : "none",
          position: "fixed",
          bottom: isMobile ? "95px" :  "70px",
          ...(isMobile ? { right: "20px" } : { left: "60px" }),
          width: isMobile ? "350px" : "480px",
          height: isMobile ? "600px" : "760px",
          border: "1px solid #ccc",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          borderRadius: "8px",
          zIndex: 1000,
          backgroundColor: "#fff",
        }}
      />

      {/* Fixed Position Wrapper - Only show if not hidden by prop */}
      {!hideLauncher && (
        <div
          style={{
            position: "fixed", // stays at bottom-left
            bottom: "20px",
            ...(isMobile ? { right: "20px" } : { left: "12px" }),
            zIndex: 1001,
          }}
        >
          {/* Relative Container for Absolute Badge */}
          <div
            style={{
              position: "relative", // anchor for badge
              width: "60px",
              height: "60px",
            }}
          >
            {/* Chat Launcher Button */}
            <div
              id="chatLauncher"
              onClick={toggleChat}
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#1f2937",
                color: "white",
                borderRadius: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "20px",
                cursor: "pointer",
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                transition: "transform 0.2s ease-in-out",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>

            {/* Notification Badge - Simple dot */}
            {hasUnreadSupport && !isChatVisible && (
              <div
                id="notificationBadge"
                style={{
                  position: "absolute",
                  top: "-2px",
                  right: "16px",
                  backgroundColor: "red",
                  borderRadius: "50%",
                  width: "10px",
                  height: "10px",
                  border: "2px solid white",
                  zIndex: 2000,
                }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ChatSupport;
